import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import config from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import {connect} from "react-redux";
import {fetchBusinessById} from "../state/actions/business";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import HowItWorksIcons from '../parts/HowItWorksIcons';
import BusinessHeader from '../parts/BusinessHeader';
import BusinessTestimonial from '../parts/BusinessTestimonial';
import BusinessEndCallToAction from '../parts/BusinessEndCallToAction';
import Footer from '../parts/Footer';

import heroBackgroundImage from '../assets/images/background-catering-hero.jpg';
import iPhoneYourShifts from '../assets/images/iphone-your-shifts.png';
import uniqueChallengeImage from '../assets/images/unique-challenge-caterer.jpg';
import iconCheck from '../assets/images/icon-check.png';


export class CateringHomePage extends React.Component {
  componentDidMount() {
    window.analytics.page("Business", "Catering");

    // Check if the user is "logged in"
    const businessId = localStorage.getItem('businessId');
    if (businessId) {
      this.props.fetchBusinessById(businessId);
    }
  }

  getStartedClicked = () => {
    if (this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    } else {
      this.props.history.push(config.routes.businessSignUp);
    }
  };

  render() {
    window.prerenderReady = true;
    const {classes} = this.props;

    return (
      <div className="business home">
        <Helmet>
          {title('SingleShift - Catering')}
          {metaTitles('SingleShift - Catering')}
          {metaDescriptions('Book online in minutes and schedule a Pro for whenever you need them in the next day or week.')}
          {metaImages(`${window.location.origin}${heroBackgroundImage}`)}
        </Helmet>
        <ScrollToTopOnMount/>

        {/* HERO */}
        <div className="hero" style={{backgroundImage: `url(${heroBackgroundImage})`}}>
          <div className="container">
            <BusinessHeader/>
            <div className="row flex-md-row-reverse align-items-center">
              <div className="col-md-6 headline">
                <h1>Easily staff your  next event</h1>
                <p>Book online in minutes and schedule a Pro for whenever you need them.</p>
                <button onClick={this.getStartedClicked} type="button" className={`${classes.heroBtn} btn btn-primary btn-xlg btn-pointer`}>Get Started</button>
              </div>
              <div className="col-md-6 text-center iphone">
                <img className="img-fluid" src={iPhoneYourShifts}/>
              </div>
            </div>
          </div>
        </div>

        {/* CHALLENGES */}
        <div className={classes.section}>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h2>Caterers face unique challenges</h2>
                <p>Unlike restaurants, caterers don't have full time service staff. Instead it relies on a pool of part-timers. SingleShift knows this isn't a perfect solution. It's cumbersome to message everyone, get their availability, only to find nobody is available.</p>
              </div>
              <div className="col-md-6">
                <img className="img-fluid" src={uniqueChallengeImage} />
              </div>
            </div>
          </div>
        </div>

        {/* HOW IT WORKS */}
        <div className={classes.section}>
          <HowItWorksIcons/>
        </div>

        {/* BUILT FOR */}
        <div className={classes.section}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <h2 className={`${classes.sectionHeader} text-center`}>SingleShift is built for reliability</h2>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <ul className="list-unstyled">
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}><b>Trusted Professionals</b>. Pros must apply and have previous experience before being allowed to work on SingleShift.</p>
                  </li>
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}><b>Ratings and Reviews</b>. Pros are rated after each shift. Higher rated pros are prioritized.</p>
                  </li>
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}><b>Last Minute Help</b>. It's rare but if their is a last minute cancellation, SingleShift will find a replacement and send them to your event at no additional cost.</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.section}>
          <BusinessTestimonial/>
        </div>

        <BusinessEndCallToAction/>

        <Footer/>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  business: state.business.item,
});

const mapDispatchToProps = (dispatch) => ({
  fetchBusinessById: (id) => dispatch(fetchBusinessById(id)),
});

const styles = (theme) => ({
  heroBtn: {
    marginBottom: '15px',
  },
  section: {
    padding: '100px 0',
    borderBottom: '1px solid #efefef',
  },
  sectionHeader: {
    paddingBottom: 30,
  },
  builtForItem: {
    overflow: 'hidden',
  },
  builtForItemImage: {
    float: 'left',
    width: '35px',
  },
  builtforItemCopy: {
    marginLeft: '45px',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CateringHomePage));



// WEBPACK FOOTER //
// ./src/pages/CateringHomePage.js